import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import clicksound from './music/click.mp3';

const ButtonTanya = ({ onClick }) => {
    // Membuat instansi Audio
    const playClickSound = () => {
        const audio = new Audio(clicksound);
        audio.play();
    };

    // Fungsi onClick yang juga memutar suara
    const handleClick = (e) => {
        playClickSound(); // Memutar suara
        if (onClick) {
            onClick(e); // Menjalankan fungsi onClick yang diteruskan sebagai props
        }
    };

    return (
        <button className="tanya-button lg:w-14 lg:h-14 sm:w-10 sm:h-10" onClick={handleClick}>
            <FontAwesomeIcon icon={faQuestion} className='sm:text-xl lg:text-2xl font-extrabold'/>
        </button>
    );
};

export default ButtonTanya;
